module.exports = __webpack_public_path__ + "static/media/addCSV.2f36cb28.svg";